import React, {useState, useContext} from 'react';
import moment from 'moment';
import { SiteContext } from '../context';
import { Link, useNavigate } from 'react-router-dom';
import ReactModal from 'react-modal';

const TableTransaction = ({orders, onDelete}) => {

  const {apiUrl, formatAmount, isMobile} = useContext(SiteContext);
  const [showModal, setShowModal] = useState(false);
  const [itemSelected, setItemSelected] = useState('');

  const handleDelete = (orderref) => {
    setItemSelected(orderref);
    setShowModal(true);
  }

  const doDelete = (orderref) => {
    onDelete(orderref);
    setItemSelected('');
    setShowModal(false);
  }

    return (
<div>
<ReactModal
      isOpen={showModal}
      style={{
        overlay: {
          flex:1,
          justifyContent: 'center',
          alignContent: 'center',
          position: 'fixed',
          top: isMobile ? '25%' : '20%',
          bottom: isMobile ? '25%' : '30%',
          left: isMobile ? '2%' : '25%',
          right: isMobile ? '2%' : '25%',
          width: isMobile ? '96%' : '50%',
          height: isMobile ? '50%' : '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.75)'
        },
        content: {
          position: 'absolute',
          top: '10px',
          left: '10px',
          right: '10px',
          bottom: '10px',
          border: '1px solid #ccc',
          background: '#fff',
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '4px',
          outline: 'none',
          padding: '20px'
        }
      }}>
        <div>
          <p className='h3 my-1 py-1'>Confirm deletion</p>
          <p className='my-1 py-2'>Action cannot be reversed!</p>
          <span className='btn btn-primary' onClick={() => doDelete(itemSelected)}>Confirm</span> <span className='btn btn-secondary' onClick={() => setShowModal(false)}>Cancel</span>
        </div>
      </ReactModal>

      <div className='container p-3'>
          <div className='row border p-1 bg-light'>
            <div className='col-1'>No</div>
            <div className='col-4'>Item</div>
            <div className='col-2'>Amount</div>
            <div className='col-3'>Customer</div>
            <div className='col-1'>Status</div>
            <div className='col-1'>Actions</div>
          </div>
          {orders.map((order,i) => {
            return (
              <div key={i} className='row small border-bottom py-1'>
              <div className='col-1'>{++i}</div>
              <div className='col-4'><Link className='btn-white bg-white border-0 text-primary' to={`/order/${order.orderref}`} >Order #{order.orderref}</Link><br />
              {moment(order.createdAt).format('Do MMM YYYY h:mma')}<br />
              </div>
              <div className='col-2'>{formatAmount(order.amount)}
              </div>
              <div className='col-3'>{order.customerfirstname} {order.customerlastname}<br />
              <span className='small text-muted'>({order.customerdeliverystatus})</span><br />
              </div>
              <div className='col-1'>O: {order.status}<br />
              P: {order.paymentstatus}</div>
              <div className='col-1'><a onClick={() => handleDelete(order.orderref)}><i className='bi bi-trash text-danger h4'></i></a>
              </div>
            </div>  
            )
          })}</div>
      </div>
    )
}

export default TableTransaction;